import styled from 'styled-components';

import PrimaryButton from '~src/shared/buttons/basicButtons/PrimaryButton.sc';

export const ButtonsBox = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
`;

export const InProgressText = styled.div`
  max-width: 410px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 22px;
`;

export const DownloadBtn = styled(PrimaryButton)`
  margin-left: 15px;
`;

export const LastRequestedTxt = styled.div`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.baseBlue.a3};
  margin-top: 10px;
`;

export const InProgressBox = styled.div`
  margin-top: 20px;
  min-height: 43px;
  position: relative;
`;

export const ErrorsBox = styled.div`
  margin-top: 15px;
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
`;
